<template>
  <div>
    <div
      :style="{
        height: videoHeight,
        width: videoWidth,
        position: 'relative',
      }"
      :class="visible ? '' : 'xb-hiden-video'"
    >
      <img
        v-if="(show_poster && poster && visible) || type == 'image'"
        :src="type == 'image' ? preImage : poster"
        class="xb-video-poster"
      />
      <div
        ref="wrapper"
        :style="{
          height: videoHeight,
          width: videoWidth,
        }"
      ></div>
    </div>
  </div>
</template>

<script>
// import "video.js/dist/video-js.min.css";
import videoJs from "video.js";
import { v4 as uuidv4 } from "uuid";
export default {
  props: {
    visible: {
      //用于音频播放的时候用，比如广播
      type: Boolean,
      default: true,
    },
    width: {
      type: String,
      default: "400px",
    },
    height: {
      type: String,
      default: "auto",
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    src: {
      type: String,
      default: "",
    },
    poster: {
      type: String,
      default: "",
    },
    showPoster: {
      type: Boolean,
      default: true,
    },
    showMsg: {
      type: Function,
      default: () => {
        return "播放失败";
      },
    },
    type: {
      type: String,
      default: "video",
    },
    preImage: {
      type: String,
      default: "",
    },
    loop: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      //全屏预览
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      video: null,
      player: null,
      options: {
        autoplay: true, // 设置自动播放
        controls: true, // 显示播放的控件
        preload: "metadata",
        loop: false,
        bigPlayButton: true,
        //   language: "zh-CN",
        liveDisplay: true,
        durationDisplay: true,
        sources: [
          // 注意，如果是以option方式设置的src,是不能实现 换台的 (即使监听了nowPlayVideoUrl也没实现)
          {
            src: "",
            //   type: "application/x-mpegURL", // 告诉videojs,这是一个hls流
          },
        ],
      },
      videoId: uuidv4(),
      show_poster: true,
      playerUrl: "", //之前的播放地址
      videoHeight: "225px",
      videoWidth: "400px",
      duration: undefined,
    };
  },
  methods: {
    waitTime(time_duration) {
      return new Promise((resolve) => {
        let a = setTimeout(() => {
          resolve("end");
          clearTimeout(a);
        }, time_duration);
      });
    },
    getVideoHtml() {
      return `<video id=${
        this.videoId
      } class="video-js" style="width:100%;height:${
        this.height == "auto" ? "auto" : "100%"
      };object-fit:contain"></video>`;
    },
    //播放器初始化
    async initPlayer(type) {
      let that = this;
      let el = document.getElementById(this.videoId);
      if (!el) {
        await this.waitTime(50);
        this.initPlayer();
        return;
      }
      if (this.src) {
        this.options.sources[0].src = this.src;
        this.options.autoplay = this.autoplay;
        this.options.loop = this.loop;
        this.options.muted = this.muted;
        this.options.controls = this.visible ? true : false;
        if (this.src.indexOf(".m3u8") == -1) {
          this.options.sources[0].type = "";
        } else {
          this.options.sources[0].type = "application/x-mpegURL";
        }
        // options.sources[0].poster = this.poster;
        this.player = videoJs(el, this.options, function () {
          el.setAttribute("playsinline", true);
          el.setAttribute("webkit-playsinline", true);
          this.on("error", function (e, b, c) {
            this.errorDisplay.contentEl().innerText = that.showMsg();
            that.$emit("error", true);
          });
          this.on("play", () => {
            console.log("播放了");
            that.show_poster = false;
            that.$emit("play", true);
          });
          this.on("pause", () => {
            console.log("暂停了");
            that.$emit("pause", true);
          });
          this.on("loadeddata", () => {
            if (that.fullScreen) {
              that.setFullscreenSize();
            }
            that.$emit("loadeddata", that.player);
            that.duration = that.player.duration();
          });
          that.video = el;
        });
        console.log("初始化完成", this.player);
      }
    },

    changeSrc() {
      if (this.playerUrl == this.src) {
        return;
      }
      if (this.showPoster) {
        this.show_poster = true;
      }

      this.playerUrl = this.src;
      if (!this.player) {
        this.initPlayer();
      } else {
        try {
          this.player.dispose();
          this.player = null;
        } catch (err) {}
        this.$nextTick(() => {
          this.$refs.wrapper.innerHTML = this.getVideoHtml();
          this.$nextTick(() => {
            this.initPlayer();
          });
        });
      }
    },

    pause() {
      if (this.player) {
        this.player.pause();
      }
    },
    changeRate(num) {
      if (num && this.player) {
        this.player.playbackRate(num);
      }
    },
    play() {
      if (this.player) {
        this.player.play();
      }
    },
    changeTime(time) {
      if (typeof time != "number" || !this.player) {
        return;
      }
      if (time <= 0) {
        this.player.currentTime(0);
      } else if (time >= this.duration) {
        this.player.currentTime(this.duration);
      } else {
        this.player.currentTime(time);
      }
    },
    setFullscreenSize() {
      let height = this.player.videoHeight();
      if (!height) {
        return;
      }
      let width = this.player.videoWidth();
      // console.log("获取到的宽高", width, height);
      let _height = Math.ceil(window.innerHeight * 0.9 - 100);
      let _width = Math.ceil((width / height) * _height);
      this.videoHeight = _height + "px";
      this.videoWidth = _width + "px";
      // console.log("设置的宽高", _width, _height);
    },
  },
  created() {
    if (this.visible) {
      this.videoHeight = this.height || this.videoHeight;
      this.videoWidth = this.width || this.videoHeight;
      this.show_poster = this.showPoster;
    } else {
      this.videoHeight = "0px";
      this.videoWidth = "0px";
    }
  },
  beforeDestroy() {
    if (this.player && this.player.dispose) {
      try {
        this.player.dispose(); // 该方法会重置videojs的内部状态并移除dom
      } catch (err) {}
    }
  },
  mounted() {
    this.$refs.wrapper.innerHTML = this.getVideoHtml();
  },
  watch: {
    src: {
      handler(newval, oldval) {
        console.log("监听到了");
        if (this.type == "image") {
          this.pause();
        } else {
          this.changeSrc();
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.xb-video-poster {
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  object-fit: cover;
}
::v-deep .vjs-big-play-button {
  z-index: 3;
  position: absolute;
  /* top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); */
}

::v-deep .video-js {
  position: relative !important;
}
::v-deep .vjs-tech {
  position: relative !important;
}
/* ::v-deep .vjs-control-bar {
  margin-bottom: 20px;
} */
/* ::v-deep .vjs-error-display.vjs-modal-dialog {
  display: none;
} */
::v-deep .xb-hiden-video .vjs-loading-spinner {
  display: none !important;
}
::v-deep .xb-hiden-video .vjs-control-bar {
  display: none !important;
}
::v-deep .xb-hiden-video .vjs-big-play-button {
  display: none !important;
}
::v-deep .xb-hiden-video .vjs-error-display {
  display: none !important;
}
/*鼠标悬浮时时间展示样式*/
/* ::v-deep .vjs-control .vjs-play-progress::after {
  width: 50px !important;
}
::v-deep .vjs-control .vjs-mouse-display::after {
  width: 50px !important;
} */
</style>
